import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoading: false,
  divisionLength: 0,
  division: [],
  divisionError: "",
  formError: "",
}

export default function divisionReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_DIVISION:
      return {...state, loading: action.payload}
    case actions.GET_DIVISION:
      return {...state, division: action.payload.division, divisionLength: action.payload.divisionLength}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.DIVISION_FAIL:
      return { ...state, divisionError: action.payload };
    default:
      return state
  }
}